import React from 'react'
import { ReactMarkdown } from 'react-markdown/lib/react-markdown'
export default function AboutIntro({ children }) {
    return (
        <div className='introduction p10'>
            <div className='max-1400 bt1 ma pt10'>
                <div className='flex mt40 m-reverse m-wrap'>
                    <div className='w-30 m-100  size-medium  pr20 text-light '>
                        Studio Overview
                    </div>
                    <div className='w-70 m-100 m-mb40'>
                        <ReactMarkdown className='m0 h3 medium text-light mb40 m0 pt0'>{children}</ReactMarkdown>


                    </div>
                </div>
            </div>
        </div>
    )
}